import Image from 'next/image'
import styled from 'styled-components'
import Text from '../../../stories/atoms/Text/Text'

import { getConfig } from '../../../service/util/config/config'

const ImageContainer = styled.div`
  margin-bottom: 24px;
`

type BrandInformationProps = {
  brand: 'nationalevacaturebank' | 'intermediair'
}

const BrandInformation = ({ brand }: BrandInformationProps) => {
  if (brand === 'intermediair') {
    return (
      <div data-testid="intermediair">
        <ImageContainer>
          <Image src={`${getConfig().ASSET_PREFIX}/images/logo-intermediair.svg`} height={30} width={160} alt="Brand logo" />
        </ImageContainer>
        <Text>
          Met ruim 55 jaar ervaring is Intermediair het worklife platform voor ambitieuze professionals. Met verrassende
          artikelen, nieuwe kansen, handvatten en concrete stappen helpen wij hoogopgeleid werkend Nederland de juiste
          keuzes te maken in het werkende leven. Intermediair heeft een groot bereik onder hoogopgeleiden en bereikt
          kandidaten in zowel het profit als non-profit segment. Bereik ook jóuw medewerkers van de toekomst met onze
          krachtige recruitment oplossingen, brede employer branding opties en onmisbare inzichten.
        </Text>
      </div>
    )
  }

  return (
    <div data-testid="nationalevacaturebank">
      <ImageContainer>
        <Image src={`${getConfig().ASSET_PREFIX}/images/logo-nationalevacaturebank.svg`} height={30} width={160} alt="nationale vacaturebank logo" />
      </ImageContainer>
      <Text>
        Met ruim 25 jaar ervaring is Nationale Vacaturebank dé expert op het gebied van recruitment. In 2022 zijn we
        voor de 12e keer uitgeroepen tot ‘Populairste Carrièresite van het Jaar’. We bieden oplossingen en uitgebreide
        content om organisaties te ondersteunen in hun zoektocht naar talent. Van het plaatsen van jouw
        vacaturecampagne, tot aan interessante artikelen en persoonlijk advies op maat, we denken graag met je mee.
      </Text>
    </div>
  )
}

export default BrandInformation
